<template>
    <div class="page page__has-bar">
        <div class="page__bd">
            <div class="weui-cells">
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">客户编号</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ form.main.ctc_cucode }}
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">客户名称</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ form.main.ctc_cuname }}
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">信用额度</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ numberFormat(form.main.ctc_credit,'¥#,##0.00') }}
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">临时信用额度</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="number" v-model="form.main.ctc_credit_temp" placeholder="请填写" @change="onTempChange" />
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">总信用额度</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ numberFormat(form.main.ctc_credit_sum,'¥#,##0.00') }}
                    </div>
                </div>
                <date-field label="截止日期" v-model="form.main.ctc_enddate" />
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">申请原因</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" v-model="form.main.ctc_remark" placeholder="请填写" />
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-bar weui-dialog__ft">
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
        </div>
    </div>
</template>

<script>
import process from "@/mixins/process.js";
import DateField from "@/components/field/DateField.vue";

export default {
    mixins: [process],
    components: {
        DateField
    },
    data() {
        return {
            baseUrl: "/api/document/customertempcredit",
            codeField: "ctc_cucode",
            statusField: "ctc_statuscode",
            caller: "CustomerTempCredit",
            xtype: "document-customer-tempcreditpanel",
            form: {
                main: {
                }
            }
        };
    },
    methods: {
        save() {
            var me = this,
                main = me.form.main
            if (!main.ctc_credit_temp) {
                me.$weui.topTips("请填写临时额度", 2000);
            } else if (!main.ctc_enddate) {
                me.$weui.topTips("请填写截止日期", 2000);
            } else if (!main.ctc_remark) {
                me.$weui.topTips("请填写申请原因", 2000);
            } else {
                me.p_save();
            }
        },
        p_save() {
            var me = this, jsonData = me.form, caller = me.caller, xtype = me.xtype
            me.$loading({
                method: "post",
                url: "/api/document/customertempcredit/save",
                jsonData
            }).then(function (res) {
                if (res.success) {
                    var data = res.data;
                    if (data && data.hasProcess) {
                        if (data.processStarted) {
                            me.$weui.toast("申请流程发起成功", 2000);
                            me.$router.back();
                        } else {
                            me.preLaunchProcess(caller, data.doc, xtype, function () {
                                me.$router.back();
                            });
                        }
                    } else {
                        me.$weui.toast("申请流程发起成功", 2000);
                        me.$router.back();
                    }
                } else {
                    me.$weui.topTips(res.message, 3000);
                }
            });
        },
        onTempChange() {
            var me = this, main = me.form.main;
            main.ctc_credit_sum = Number(main.ctc_credit || 0) + Number(main.ctc_credit_temp || 0);
        }
    },
};
</script>